import { render } from "./student_register_confirmation.vue?vue&type=template&id=944c7986&scoped=true"
import script from "./student_register_confirmation.vue?vue&type=script&lang=js"
export * from "./student_register_confirmation.vue?vue&type=script&lang=js"

import "./student_register_confirmation.vue?vue&type=style&index=0&id=944c7986&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-944c7986"]])

export default __exports__